"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var util_1 = require("util");
var kotlin = require("kotlin");
/***************************************** IMPORT JAVELIN *****************************************/
var javelinWrapperImport = __importStar(require("@canimmunize/kotlinjavelin"));
var javelinWrapper = javelinWrapperImport;
exports.javelin = javelinWrapper.ca.ohri.javelin;
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory("javelin-exports", shared_1.Styles.lakeLouise);
exports.Type = exports.javelin.data.util.Type;
exports.SyncType = exports.javelin.sync.util.SyncType;
exports.AccountValidation = exports.javelin.sync.util.AccountValidation;
exports.Action = exports.javelin.data.util.Action;
exports.Id = exports.javelin.util.Id;
/********************************************* EXPORT *********************************************/
/**
 * Convenience export to reference ca.ohri.javelin.data.model
 */
exports.javelinModel = exports.javelin.data.model;
/**
 * Required interfaces (note: not implemented - just the empty exports).
 */
exports.JLocalDate = exports.javelinModel.date.JLocalDate;
exports.JZonedDateTime = exports.javelinModel.date.JZonedDateTime;
/**
 * Export string IDs (for translations, etc.).
 */
exports.StringIds = exports.javelin.util.Id;
log.verbose("StringIds:", exports.StringIds);
// Examine javelin (post-typings attachment)
log.verbose("inspect javelin - typed:", util_1.inspect(exports.javelin, false, 12));
/***************************************** BARREL EXPORTS *****************************************/
//
// Constants
//
__export(require("../.constants/Field"));
//
// Export user-related data / models
//
__export(require("./model/consent"));
//
// Export dates
//
var javelin_date_1 = require("./date/javelin-date");
exports.JavelinDate = javelin_date_1.JavelinDate;
var date_time_all_1 = require("./date/date-time-all");
exports.LocalDate = date_time_all_1.LocalDate;
exports.ZonedDateTime = date_time_all_1.ZonedDateTime;
//
// Export managers / manager models
//
var javelin_manager_1 = require("./model/managers/javelin-manager");
exports.JavelinManager = javelin_manager_1.JavelinManager;
exports.javelinManagerFactory = javelin_manager_1.javelinManagerFactory;
__export(require("./model/managers/data-manager"));
__export(require("./model/managers/sync-manager"));
__export(require("./model/managers/notification-manager"));
__export(require("./model/managers/scheduler-manager"));
__export(require("./model/interfaces/javelin-date-interface"));
//
// Export concept models
//
__export(require("./model/concept/generic-concept"));
__export(require("./model/concept/concept"));
__export(require("./model/concept/vaccine-concept"));
__export(require("./model/concept/trade-name-concept"));
__export(require("./model/concept/disease-concept"));
//
// Export basic data models
//
__export(require("./model/banner"));
__export(require("./model/country"));
__export(require("./model/city"));
__export(require("./model/disease"));
__export(require("./model/vaccine"));
__export(require("./model/schedule"));
__export(require("./model/record"));
__export(require("./model/dose"));
__export(require("./model/generator-collection"));
__export(require("./model/dose-generator"));
//
// Export callbacks / transactions (sync-related)
//
__export(require("./model/sync/request-callback"));
__export(require("./model/sync/response-callback"));
__export(require("./model/sync/transaction"));
__export(require("./model/sync/account"));
//
// Export utility models
//
__export(require("./model/local-notification"));
__export(require("./model/notification"));
__export(require("./model/filter"));
__export(require("./model/faq"));
__export(require("./model/rule"));
//
// Export integrations
//
__export(require("./model/phu-config"));
__export(require("./model/integrations/integration"));
__export(require("./model/integrations/phu-integration"));
//
// Export utility models
//
__export(require("./model/util/date-modifier"));
__export(require("./model/util/region"));
//
// Export result models
//
__export(require("./model/result/error"));
__export(require("./model/result/result"));
__export(require("./model/result/success"));
//
// Export page models
//
__export(require("./model/page/page"));
__export(require("./model/page/other-page"));
//
// Export enum-like models
//
__export(require("./model/enum-like/relationship"));
__export(require("./model/enum-like/gender"));
__export(require("./model/enum-like/status"));
__export(require("./data/hydrators/regions"));
//# sourceMappingURL=javelin-exports.js.map